import * as React from 'react';
import {Modal} from '@material-ui/core';
import {SecondaryButton} from '@screens/review-section3/pincode-authorisation/styles';
import {PrimaryButton} from '@screens/review-section3/pincode-authorisation/pin-code-form-styles';
import {ModalCloseIcon, ModalContent, ModalFooter, ModalLabel, ModalStyle, ModalTitle} from '@components/modal/styles';

interface IProps {
    title: string;
    message?: string;
    cancelLabel?: string;
    confirmLabel?: string;
    modalFooterContentDisplay?: string;
    onConfirmClickHandler?: () => void;
    onCancelClickHandler?: () => void;
    onCloseClickHandler?: () => void;
    isOpen: boolean;
    hideFooter?: boolean;
    style?: React.CSSProperties;
    className?: string;
    canConfirm?: boolean;
}

export class ModalContainer extends React.Component<IProps> {
    static defaultProps = {
        canConfirm: true
    }
    constructor(props: IProps) {
        super(props);
    };

    onCancel = () => {
        // tslint:disable-next-line:no-unused-expression
        this.props.onCancelClickHandler &&
        this.props.onCancelClickHandler();
    };

    onConfirm = () => {
        if (!this.props?.canConfirm) return;
        // tslint:disable-next-line:no-unused-expression
        this.props.onConfirmClickHandler &&
        this.props.onConfirmClickHandler();
    };

    render() {
        const message = this.props.message ? <ModalLabel> {this.props.message} </ModalLabel> : null;
        const cancelLabel = this.props.cancelLabel || 'Cancel';
        const confirmLabel = this.props.confirmLabel || 'Ok';

        const cancelButton = this.props.onCancelClickHandler ? (
            <SecondaryButton onClick={this.onCancel}>
                {cancelLabel}
            </SecondaryButton>
        ) : null;
        const closeButton = this.props.onCloseClickHandler ?
            (<ModalCloseIcon>
                <i onClick={this.props.onCloseClickHandler} className='material-icons'>clear</i>
            </ModalCloseIcon>)
            :
            null;

        const modelFooter = this.props.hideFooter ? null : (
            <ModalFooter>
                {cancelButton}
                <PrimaryButton onClick={this.onConfirm} disabled={!this.props?.canConfirm}>
                    {confirmLabel}
                </PrimaryButton>
            </ModalFooter>
        );

        return (
            <Modal open={this.props.isOpen}
                   disableEnforceFocus={true}
                   disableEscapeKeyDown={true}
                   disableAutoFocus={true}
                   onClose={this.onCancel}>
                <ModalStyle
                    top='50%'
                    left='50%'
                    style={this.props.style}
                    className={this.props.className}
                >
                    <ModalTitle>{this.props.title} {closeButton}</ModalTitle>
                    <ModalContent>
                        {message}
                        {this.props.children}
                    </ModalContent>
                    {modelFooter}
                </ModalStyle>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/modal.tsx